import { Component, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import * as blackLoading from '../../../../assets/lottie/loading-black.json';
import * as greenLoading from '../../../../assets/lottie/loading-green.json';

@Component({
  selector: 'app-lottie-loader',
  template: `<ng-lottie [height]="height" [options]="options"></ng-lottie>`,
})
export class LottieLoaderComponent implements OnInit {
  @Input() height!: string;
  @Input() color!: 'BLACK' | 'GREEN';
  options!: AnimationOptions;

  ngOnInit(): void {
    const loadingData = this.color === 'BLACK' ? blackLoading : greenLoading;
    this.options = { animationData: loadingData };
  }
}
